module.exports = __webpack_public_path__ + "img/gkPc.dcfd01c3.jpg";